export class LoadAccountsProvincesNamingsFromApi {
    public static readonly type: string = '[Accounts API] Load province Mappings';
}
